// Status translations and utilities
// Database uses English values, UI shows localized Finnish strings

// The stages of utils/stageStatus.js: draft and pre-workshop are Valmistelu,
// running Toteutus, post-workshop and archived Tulokset. Status is the
// lifecycle only; the workshop's structure is its module chain. day2 was
// folded into day1 (migration 268, #914), day1 renamed running (290, #1161).
export const STATUS_VALUES = {
  DRAFT: 'draft',
  PRE_WORKSHOP: 'pre-workshop',
  RUNNING: 'running',
  POST_WORKSHOP: 'post-workshop',
  ARCHIVED: 'archived'
};

// Finnish translations for status values
export const STATUS_LABELS_FI = {
  [STATUS_VALUES.DRAFT]: 'Luonnos',
  [STATUS_VALUES.PRE_WORKSHOP]: 'Valmistelu',
  [STATUS_VALUES.RUNNING]: 'Toteutus',
  [STATUS_VALUES.POST_WORKSHOP]: 'Tulokset',
  [STATUS_VALUES.ARCHIVED]: 'Arkistoitu'
};

export const STATUS_LABELS_EN = {
  [STATUS_VALUES.DRAFT]: 'Draft',
  [STATUS_VALUES.PRE_WORKSHOP]: 'Preparation',
  [STATUS_VALUES.RUNNING]: 'Running',
  [STATUS_VALUES.POST_WORKSHOP]: 'Results',
  [STATUS_VALUES.ARCHIVED]: 'Archived'
};

export const STATUS_LABELS_SV = {
  [STATUS_VALUES.DRAFT]: 'Utkast',
  [STATUS_VALUES.PRE_WORKSHOP]: 'Förberedelse',
  [STATUS_VALUES.RUNNING]: 'Genomförande',
  [STATUS_VALUES.POST_WORKSHOP]: 'Resultat',
  [STATUS_VALUES.ARCHIVED]: 'Arkiverad'
};

// Get localized label for a status value
export function getStatusLabel(status, locale = 'fi') {
  const map =
    locale === 'fi' ? STATUS_LABELS_FI
      : locale === 'sv' ? STATUS_LABELS_SV
        : locale === 'en' ? STATUS_LABELS_EN
          : null;
  if (map && map[status]) return map[status];
  // Fallback: capitalize English-ish value
  return status.charAt(0).toUpperCase() + status.slice(1).replace(/-/g, ' ');
}

// Status values that should be hidden from regular users (only visible to facilitators)
export const HIDDEN_STATUSES = [STATUS_VALUES.DRAFT, STATUS_VALUES.ARCHIVED];

// Check if a status should be hidden from users
export function isStatusHiddenFromUsers(status) {
  return HIDDEN_STATUSES.includes(status);
}

/** Legacy DB values before migration 021 */
const LEGACY_VISIBLE_STATUSES = ['pre-kuutio', 'active', 'post-kuutio', 'luonnos'];

/**
 * Admin header / facilitator instance picker — show active workshops, hide archived & soft-deleted.
 * The server already leaves archived_at rows out of the instance list (#1209); this is the belt.
 * @param {{ status?: string, deleted_at?: string | null, archived_at?: string | null }} instance
 */
export function isInstanceVisibleInAdminSelector(instance) {
  if (!instance || instance.deleted_at || instance.archived_at) return false;
  const status = instance.status;
  if (!status) return true;
  if (status === STATUS_VALUES.ARCHIVED || status === 'arkisto') return false;
  const visible = new Set([
    STATUS_VALUES.DRAFT,
    STATUS_VALUES.PRE_WORKSHOP,
    STATUS_VALUES.RUNNING,
    STATUS_VALUES.POST_WORKSHOP,
    ...LEGACY_VISIBLE_STATUSES,
  ]);
  return visible.has(status);
}
